module.exports = __webpack_public_path__ + "static/media/eupmc.8c837e5a.png";